module.exports = __webpack_public_path__ + "static/media/note.278bd7dd.png";